/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiCustomListSchemaFieldType } from './InternalApiCustomListSchemaFieldType';
import {
    InternalApiCustomListSchemaFieldTypeFromJSON,
    InternalApiCustomListSchemaFieldTypeFromJSONTyped,
    InternalApiCustomListSchemaFieldTypeToJSON,
    InternalApiCustomListSchemaFieldTypeToJSONTyped,
} from './InternalApiCustomListSchemaFieldType';

/**
 * 
 * @export
 * @interface InternalApiCustomListSchemaField
 */
export interface InternalApiCustomListSchemaField {
    /**
     * 
     * @type {string}
     * @memberof InternalApiCustomListSchemaField
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCustomListSchemaField
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCustomListSchemaField
     */
    fieldName: string;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiCustomListSchemaField
     */
    isMulti: boolean;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCustomListSchemaField
     */
    parentId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiCustomListSchemaField
     */
    enumOptions?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiCustomListSchemaField
     */
    isNullable: boolean;
    /**
     * 
     * @type {number}
     * @memberof InternalApiCustomListSchemaField
     */
    sortOrder: number;
    /**
     * 
     * @type {InternalApiCustomListSchemaFieldType}
     * @memberof InternalApiCustomListSchemaField
     */
    type: InternalApiCustomListSchemaFieldType;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiCustomListSchemaField
     */
    visibleInMatches: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiCustomListSchemaField
     */
    visibleInList: boolean;
}



/**
 * Check if a given object implements the InternalApiCustomListSchemaField interface.
 */
export function instanceOfInternalApiCustomListSchemaField(value: object): value is InternalApiCustomListSchemaField {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('fieldName' in value) || value['fieldName'] === undefined) return false;
    if (!('isMulti' in value) || value['isMulti'] === undefined) return false;
    if (!('isNullable' in value) || value['isNullable'] === undefined) return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('visibleInMatches' in value) || value['visibleInMatches'] === undefined) return false;
    if (!('visibleInList' in value) || value['visibleInList'] === undefined) return false;
    return true;
}

export function InternalApiCustomListSchemaFieldFromJSON(json: any): InternalApiCustomListSchemaField {
    return InternalApiCustomListSchemaFieldFromJSONTyped(json, false);
}

export function InternalApiCustomListSchemaFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCustomListSchemaField {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'displayName': json['displayName'],
        'fieldName': json['fieldName'],
        'isMulti': json['isMulti'],
        'parentId': json['parentId'] == null ? undefined : json['parentId'],
        'enumOptions': json['enumOptions'] == null ? undefined : json['enumOptions'],
        'isNullable': json['isNullable'],
        'sortOrder': json['sortOrder'],
        'type': InternalApiCustomListSchemaFieldTypeFromJSON(json['type']),
        'visibleInMatches': json['visibleInMatches'],
        'visibleInList': json['visibleInList'],
    };
}

export function InternalApiCustomListSchemaFieldToJSON(json: any): InternalApiCustomListSchemaField {
    return InternalApiCustomListSchemaFieldToJSONTyped(json, false);
}

export function InternalApiCustomListSchemaFieldToJSONTyped(value?: InternalApiCustomListSchemaField | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'displayName': value['displayName'],
        'fieldName': value['fieldName'],
        'isMulti': value['isMulti'],
        'parentId': value['parentId'],
        'enumOptions': value['enumOptions'],
        'isNullable': value['isNullable'],
        'sortOrder': value['sortOrder'],
        'type': InternalApiCustomListSchemaFieldTypeToJSON(value['type']),
        'visibleInMatches': value['visibleInMatches'],
        'visibleInList': value['visibleInList'],
    };
}

